import { render, staticRenderFns } from "./dose_model.vue?vue&type=template&id=ec7a4b90&scoped=true"
import script from "./dose_model.vue?vue&type=script&lang=js"
export * from "./dose_model.vue?vue&type=script&lang=js"
import style0 from "./dose_model.vue?vue&type=style&index=0&id=ec7a4b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7a4b90",
  null
  
)

export default component.exports